import React, { useEffect, useState } from "react";
import styles from "./ProgramBanner.module.css";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import Image from "next/image";
import { useRouter } from "next/router";
import CustomiseCta from "../CustomiseCta/CustomiseCta";
import useIsMobile from "../../hooks/useIsMobile";

type ImageType = {
  id?: number;
  documentId?: string;
  url?: string;
  alternativeText?: string;
};

type ProgramBannerProps = {
  PopupData?: any;
  programOfIntrestLP?: any;
  programOfInterestMultipleOptionList?: boolean;
  data: {
    cta: any;
    card_with_image: {
      title_description?: {
        title?: string;
        description?: string;
      };
      images?: ImageType[];
      mobiles_images?: ImageType[];
    };
  };
};

const ProgramBanner: React.FC<ProgramBannerProps> = ({
  data,
  PopupData,
  programOfIntrestLP,
  programOfInterestMultipleOptionList,
}) => {
  const router = useRouter();
  const [pageSlug, setPageSlug] = useState("");
  const isMobile = useIsMobile();

  useEffect(() => {
    const slug = router?.asPath?.split("/")?.filter(Boolean)?.join("/");
    setPageSlug(slug || "home");
  }, [router.asPath]);

  const { title_description, images, mobiles_images } =
    data?.card_with_image || {};
  const isLpPage = router.asPath.startsWith("/lp/");

  // Choose images based on device type
  const displayImages = isMobile ? mobiles_images : images;

  return (
    <>
      <div
        className={
          isLpPage
            ? `${styles.bannerContainer} ${styles.bannerContainerLP}`
            : styles.bannerContainer
        }
      >
        <div className="container">
          {isLpPage && (
            <Image
              src={"/assets/reg_logo.png"}
              alt="Program Banner"
              width={170}
              height={40}
              priority
              className={styles.regLogo}
            />
          )}
          <div className={styles.bannerContent}>
            {!isLpPage && (
              <div className={styles.breadcrumb}>
                <Breadcrumbs />
              </div>
            )}
            <h1 className={styles.title}>{title_description?.title}</h1>
            <p className={styles.description}>
              {title_description?.description}
            </p>
            <div className={styles.imagesContainer}>
              {displayImages?.map((image) =>
                image?.url ? (
                  <Image
                    key={image?.id}
                    src={image?.url}
                    alt={image?.alternativeText || "Program image"}
                    title={image?.alternativeText || "Program image"}
                    className={styles.image}
                    width={136}
                    height={60}
                    style={{
                      width: 136,
                      height: 60,
                      aspectRatio: 136 / 60,
                    }}
                  />
                ) : null
              )}
              {data?.cta && (
                <div className={styles.mobileEnquire}>
                  <div className={styles.contactButton}>
                    <CustomiseCta
                      ctaData={data?.cta}
                      pageSlug={pageSlug}
                      isProgramPage="contact"
                      popupData={PopupData}
                      programOfIntrestLP={programOfIntrestLP}
                      programOfInterestMultipleOptionList={
                        programOfInterestMultipleOptionList
                      }
                    />
                  </div>
                </div>
              )}
            </div>
            <div className={styles.FormSpace}></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProgramBanner;
